import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";
import { isTokenExpired } from "../../helpers/authToken";

// Treat an expired token as no token, so every consumer of useProfile (notably
// AuthProtected) sees the session as ended before any protected UI renders.
const activeToken = (session) => {
  const token = session && session["token"];
  return token && !isTokenExpired(token) ? token : null;
};

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  var token = activeToken(userProfileSession);
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    var token = activeToken(userProfileSession);
    setUserProfile(userProfileSession ? userProfileSession : null);
    setLoading(token ? false : true);
  }, []);


  return { userProfile, loading,token };
};

export { useProfile };